Vue.config.devtools = true;

Vue.component('account-info', {
    props: {
        account: {
            type: Object,
            default: function () {
                return {
                    AccountNumber: "000000000000",
                    ContragentShortName: "Пустой компонент",
                    ContractNumber: "Договор поставки тепла",
                    ContractDate: "20.09.2018",
                    ContractRSO: "20.09.2018",
                    Balans: { AccountId: 2833899, DivisionId: 80, BalansSum: 994952.6 },
                    Division: { Caption: '' },
                    Invoices: {
                        AccountId: 2833899,
                        PeriodStart: "2019-10-01T00:00:00",
                        PeriodEnd: "2019-10-31T00:00:00",
                        InvoiceType: {
                            Id: 62,
                            Type: "Пени"
                        },
                        DeptStart: 4737.24,
                        AdvanceAccrual: 0.0,
                        PayInPeriod: 0.0,
                        DeptEnd: 4737.24
                    },
                    ContractOrder: {
                        DatabaseId: "Omnis_NSK_LKK",
                        DivisionId: 80,
                        AccountId: 2833899,
                        PayPeriods: {
                            Order: 0,
                            Persent: 0,
                            Day: 0
                        }
                    }
                };
            }
        }
    },
    template:
        `
        <div>
            <div class="object object--account block">
                <div class="object__table">
                    <div class="object__cell object__cell--number h5">
                        <div class="object__label">Номер лицевого счета:</div>
                        <div class="object__value object__value--entity h2">{{AccountNumber}}</div>
                    </div>
                    <div class="object__cell object__cell--title h5">
                        <div class="object__label">Номер договора:</div>
                        <div class="object__value" v-if="Division.Id == 1102">«Холодное водоснабжение и водоотведение»</div>
                        <div v-else>«Отопление и горячее водоснабжение»</div>
                        <div class="object__value">№ {{ ContractNumber }} от {{ ContractDate | formatDate }}г. c {{Division.Caption}} </div>
                        
                    </div>
                    <div class="object__cell object__cell--sm object__cell--right h5">
                        <div class="object__label">Баланс:</div>
                        <div class="object__value h3"> {{ Balans.BalansSum | ruF2 }} ₽</div>
                    </div>
                </div>
                <div class="object__right">
                    <div class="object__buttons">
                        <a class="object__ctrl button button--th-ctrl" href="/UL/equipment/equipments">Передать <br>показания</a>
                        <a class="object__ctrl button button--th-main" href="/UL/payment/index/">Оплатить</a>
                    </div>
                    <div class="object__toggle">
                        <a class="collapse-link collapse-link--second link link--underline " v-bind:href="'#objInfo_'+AccountNumber" data-toggle="collapse">
                            <span class="link__text">Состояние расчетов</span>
                            <span class="link__icon fab-icon">
                                <i class="icon icon--angle-down"></i>
                            </span>
                        </a>
                    </div>
                </div>
            </div>
            <div class="object-info accordion-body collapse" v-bind:id="'objInfo_'+AccountNumber">
                <div class="object-info__inner accordion-body__inner">
                    <div class="object-info__section object-info__section--short block">
                        <div class="request-table request-table--account">
                            <div class="request-table__row request-table__row--head h5">
                                <div class="request-table__cell">Тип начисления</div>
                                <div class="request-table__cell">Задолженность <br>на начало месяца</div>
                                <div class="request-table__cell">Авансовые начисления <br> текущего месяца</div>
                                <div class="request-table__cell">Оплачено <br>в текущем месяце</div>
                                <div class="request-table__cell">Задолженность <br> на&nbsp;{{ deptDate | formatDate }}</div>
                            </div>
                            <section v-for="invoice in Invoices">
                               <div class="request-table__row h5" v-bind:class="invoice.InvoiceType.Id==-1 ? 'request-table__row--total' : ''" >
                                   <div class="request-table__cell request-table__cell--title ex-small">
                                       {{invoice.InvoiceType.Type}}
                                   </div>
                                   <div class="request-table__cell">
                                       <div class="request-table__label">Задолженность <br>на начало месяца </div>
                                       {{invoice.DeptStart  | ruF2}} ₽
                                   </div>
                                   <div class="request-table__cell">
                                       <div class="request-table__label">Авансовые начисления <br> текущего месяца</div>
                                       {{invoice.AdvanceAccrual  | ruF2}} ₽
                                   </div>
                                   <div class="request-table__cell">
                                       <div class="request-table__label">Оплачено <br>в текущем месяце</div>
                                       {{invoice.PayInPeriod  | ruF2}} ₽
                                   </div>
                                   <div class="request-table__cell">
                                       <div class="request-table__label">Задолженность <br> на&nbsp;{{ deptDate | formatDate }}</div>
                                       {{invoice.DeptEnd | ruF2}} ₽
                                   </div>
                               </div>
                            </section>
                        </div>
                    </div>
                </div>
            </div>
            <div class="objects__info block">
                <div class="account-info">
                    <div v-if="payordercount > 0" class="account-info__item">
                       <div class="account-info__label">Порядок расчета по договору:</div> 
                       <div class="account-info__value">{{payorderstr}}</div>
                    </div>
                    <div class="account-info__item">
                        <div class="account-info__label">Дата окончательного расчёта:</div>
                        <div class="account-info__value">до 10 числа следующего месяца</div>
                    </div>
                </div>
            </div>
        </div>
        `
    ,
    data() {
        return {
            AccountNumber: this.account.AccountNumber,
            ContragentShortName: this.account.ContragentShortName,
            Division: this.account.Division,
            Balans: this.account.Balans,
            Invoices: this.account.Invoices,
            ContractOrder: this.account.ContractOrder,
            ContractNumber: this.account.ContractNumber,
            ContractDate: this.account.ContractDate,
            ContractRSO: this.account.ContractRSO,
            deptDate: Date.now()
        };
    },
    filters: {
        ruF2(number) {
            if (number === null) return 0;
            return number.toLocaleString('ru-RU');
        },

        formatDate(value) {
            if (value) {
                return moment(value).format('DD.MM.YYYY');
            }
            return "";
        }
    },
    computed: {
        payorderstr() {
            var str = '';
            this.ContractOrder.PayPeriods.forEach(function (item) {
                if (item.Order !== 0)
                    str += item.Order + '-й этап до ' + item.Day + ' — ' + item.Persent + '% от общей плановой стоимости ';
            });
            return str;
        },
        payordercount() {
            var cnt = 0;
            this.ContractOrder.PayPeriods.forEach(function (item) {
                if (item.Order !== 0) cnt++;
            });
            return cnt;

        }
    }
});


if (document.querySelectorAll("#app").length)
new Vue({
    el: '#app',
    data() {
        return {
            info: null,
            balans: [],
            tuList: [],
            tuGroup: [],
            loading: true,
            errored: false
        };
    },
    mounted() {
        axios
            .get('/ul/index/mainlink')
            .then(response => {
                this.info = response.data;
                this.loadBalans(this.info.balansLink);
                this.loadTU(this.info.tuLink);
            })
            .catch(error => {
                console.log(error);
                this.errored = true;
            })
            .finally(() => (this.loading = false));
    },
    filters: {
        f4(value) {
            return value;//.toFixed(4);
        },
        ruF2(number) {
            if (number === null) return 0;
            return number.toLocaleString('ru-RU');
        },

        formatDate(value) {
            if (value) {
                return value.substring(8, 10) + "." + value.substring(5, 7) + "." + value.substring(0, 4);
            }
        }
    },

    methods: {
        loadBalans: function (link) {

            var self = this;
            axios
                .get(link)
                .then(response => {
                    this.balans = response.data.Data;
                })
                .catch(error => {
                    console.log(error);
                    this.errored = true;
                })
                .finally(() => (this.loading = false));

        },

        loadTU: function (link) {
            var self = this;
            axios
                .get(link)
                .then(response => {
                    this.tuList = response.data.Data;
                    this.tuGroup = self.groupBy(response.data.Data, 'AddressShort');
                    console.log(this.tuGroup);
                })
                .catch(error => {
                    console.log(error);
                    this.errored = true;
                })
                .finally(() => (this.loading = false));
        },

        groupBy: function (array, key) {
            const result = {}
            array.forEach(item => {
                if (!result[item[key]]) {
                    result[item[key]] = []
                }
                result[item[key]].push(item)
            });
            return result
        }

    }
});


// WEBPACK FOOTER //
// ./wwwroot/app/UL/main.js